import { MetricCode } from '@/entities/metrics'

type ProjectMetricsParams = {
  projectId: string
}

type ProjectMetricByCodeParams = {
  projectId: string
  metricCode: MetricCode
}

const endpoints = {
  getMetrics: 'api/v2/metrics/',
  projectMetrics: ({ projectId }: ProjectMetricsParams): string => {
    return `api/v2/users/user-id/projects/${projectId}/metrics/`
  },
  projectMetricByCode: ({ projectId, metricCode }: ProjectMetricByCodeParams): string => {
    return `api/v2/users/user-id/projects/${projectId}/metrics/${metricCode}/`
  },
}

export default endpoints
